// Central Chart.js registration for the Overview tab charts.
// Importing this module once registers the controllers/elements used by
// react-chartjs-2 (tree-shakable build in chart.js v4).
import {
    Chart as ChartJS,
    ArcElement,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend
} from 'chart.js'

ChartJS.register(
    ArcElement,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend
)

export default ChartJS
